import type { User } from '@sentry/nextjs';
import { useRouter } from 'next/router';
import { useContext, useEffect } from 'react';

import useGetLoginUser from '@/modules/User/user/useGetLoginUser';

import Break from '../CampSite/camp/Break';
import { GlobalContext } from './state';

export const useBrowserBack = () => {
  const router = useRouter();
  const { user: loginUser } = useGetLoginUser();
  const { setDialogStatus, isEdit, setIsEdit } = useContext(GlobalContext);

  const handlePopstate = () => {
    const path = router.pathname as string;

    const getUrl = () => {
      if (path.match(/\/camper\[camper_id\]\/log\/\[id\]\/edit/) !== null) {
        return `/camper/${(loginUser as User).id}/log/`;
      }
      if (path.match(/\/camp/) !== null) {
        return `/camp/${router.query.id as string}/`;
      }
      if (path.match(/\/contact\/\[path\]/) !== null) {
        return `/contact/${router.query.path as string}/`;
      }
      return '/';
    };

    const allowBack = () => {
      setIsEdit(false);
      window.history.go(1);
    };

    const cancel = () => {
      window.history.pushState(null, '', null);
    };

    setDialogStatus({
      open: true,
      type: 'COMMON',
      props: { allowBack, cancel },
      children: (
        <Break
          title="本当に入力を中断しますか？"
          description="入力内容は破棄されますがよろしいですか。"
          routerPath={getUrl()}
        />
      ),
    });
  };

  useEffect(() => {
    // @FIXME: 連続で戻るを押した場合と、3回キャンセルするとレンダリングされて入力内容消える
    if (isEdit) {
      window.history.pushState(null, '', null);
      window.addEventListener('popstate', handlePopstate, false);
    }
    return () => {
      window.removeEventListener('popstate', handlePopstate, false);
      window.history.pushState(null, '', null);
    };
  }, [isEdit]);

  return <></>;
};
